import Page404 from './components/404';

export default Page404;


// WEBPACK FOOTER //
// ./routes/404/index.js